import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const TeammateContentRecommendationBanner: LoadableType<{
	contentId: string;
	isLivePage: boolean;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TeammateContentRecommendationBanner" */ '../src/components/teammate-content-recommendation-banner/TeammateContentRecommendationBanner.tsx'
			)
		).TeammateContentRecommendationBanner,
});
